export default "__VITE_ASSET__Rt0wQ54D__"